import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";

function Agreement() {
  return (
    <Fragment>
      <Helmet>
        <title>Agreement - d2p</title>
      </Helmet>
      <PageBanner title="Agreement" image="/assets/images/bg4.jpg" />
      <div
        style={{
          margin: "70px auto",
          textAlign: "center",
          maxWidth: "1000px",
          width: "85%",
        }}
      >
        <p style={{ fontSize: "20px" }}>
          By using this website to sell or distribute your literary work(s), you
          hereby agree not to hold decade 2 publishing, its parent company,
          Continent 5 Media Group, or its employs, associates, or affiliates
          liable, responsible, or accountable for loss or harm from any action
          sustained by you, or caused by you, or brought against you, your name,
          stead, likeness, alias, moniker, surname, or any other name under
          which you write, use, or perform under, individually and collectively.
        </p>
      </div>
    </Fragment>
  );
}

export default Agreement;
